module.exports = __webpack_public_path__ + "img/empty-data.d3580d75.png";